var _circle, _circle2, _circle3, _circle4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressArrowRightActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 153,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 130,
    r: 11,
    fill: "#10C98E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 23,
    cy: 130,
    r: 14.75,
    stroke: "#10C98E",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 23,
    cy: 130,
    r: 22.75,
    stroke: "#10C98E",
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 6,
    r: 5,
    fill: "#4AD6AA",
    stroke: "#4AD6AA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18 93.144l6.145 6.144 6.144-6.144",
    stroke: "#10C98E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405 15v24.294c0 11.046-8.954 20-20 20H44c-11.046 0-20 8.954-20 20V95",
    stroke: "#4AD6AA",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })));
}
export default SvgProgressArrowRightActive;